import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  ChatBubbleOvalLeftIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";
import { PrimaryMobile } from "../../../buttons/mobile/Primary";
import { APIClient } from "../../../../helpers/api_helper";
import * as url from "../../../../helpers/url_helper";
import { parsedStatusReferrals, statusReferrals } from "../../../../utils/referrals/status";

const api = new APIClient();

export function FriendsList() {
  const [open, setOpen] = useState(false);
  const [myReferrals, setMyReferrals] = useState([]);
  const [isloading, setIsLoading] = useState(true);

  const handleMapDescription = (status_db, name, bonus, dayLimit, currentScore) => {
    const key = Object.keys(statusReferrals).find(key => statusReferrals[key] === status_db);
    let description = '';
    let negativePoints = null;
    let points = bonus;

    function getKey(value) {
      let _key = Object.keys(statusReferrals).find(key => statusReferrals[key] === value);
      return _key;
    }

    switch (key) {
      case getKey(statusReferrals.CF):
        description = `${name} te ha hecho conseguir ${bonus} puntos porque adquirió un crédito. Para conseguir 200 puntos más solo debes pedirle que pague antes de su fecha límite.`;
        break;
      case getKey(statusReferrals.EM):
        description = `${name} está en mora ¡pero aún estás a tiempo de no perder puntos!, envíale un mensaje para que pague antes del ${dayLimit}.`
        break;
      case getKey(statusReferrals.PM):
        description = `${name} ha tenido dificultades para hacer su pago antes de la fecha límite, es por eso que has perdido ${bonus} puntos.`;
        negativePoints = bonus;
        points = null;
        break;
      case getKey(statusReferrals.PT)://Se debe agregar el bonus actual del usuario.
        description = `${name} pagó a tiempo el crédito que adquirió en Galilea y te ha hecho ganar ${bonus} puntos en total, envíale un mensaje de agradecimiento.`
        break;
      default:
        break;
    }
    return { description, negativePoints, points };
  }

  const handleMapStatus = (status_db) => {
    // Buscar la clave en statusReferrals que corresponde al value
    const key = Object.keys(statusReferrals).find(key => statusReferrals[key] === status_db);
    // Devolver el valor correspondiente en parsedStatusReferrals si existe
    return key ? parsedStatusReferrals[key] : null;
  }

  const handleGetReferrals = async () => {
    try {
      setOpen(true);
      let { data, status } = await api.get(`${url.GET_MY_REFERRALS}?idParent=${localStorage.getItem('doc')}`);
      if (status === 200 && 'data' in data) {
        let referralData = data?.data ?? [];
        if (Array.isArray(referralData) && referralData.length > 0) {
          let parsedData = referralData.map((item) => {
            let { negativePoints, description, points } = handleMapDescription(item?.status, item?.name, item?.bonus, item?.tentativeDatePayment, item?.currentScore)
            return {
              name: item?.name,
              avatar: "/jpeg/mario_astronauta.jpeg",
              status: handleMapStatus(item?.status),
              points: points,
              description: description,
              action: '#',
              negativePoints: negativePoints
            }
          })
          setMyReferrals(parsedData);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className={"w-full"} onClick={handleGetReferrals} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between text-white">
            <span className="absolute" />
            <span className="sr-only">Lista de amigos</span>
            <PrimaryMobile text="Mis referidos" />
          </div>
        </div>
      </div>


      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-closed:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div>
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{cursor: "pointer"}}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Mis referidos</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-hidden"
                            style={{cursor: "pointer"}}
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-purpleLight p-4 overflow-y-auto">
                    <div className="flex justify-between text-grayP py-4">
                      <div>Referidos</div>
                      <div>({myReferrals.length})</div>
                    </div>

                    {
                      isloading ? (
                        <>
                          <div className="p-3 text-grayP" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div >
                              <div className="loader-clousure-movements"> </div>
                            </div>
                            Viajando...
                          </div>
                        </>
                      ) :
                        (
                          <>
                            {myReferrals.map((friend) => (
                              <div className="bg-white rounded-2xl p-2 mb-4">
                                <div className="flex justify-between">
                                  <div className="flex gap-2">
                                    <div>
                                      <img
                                        className="h-10 w-auto rounded-full cursor-pointer"
                                        src={friend.avatar}
                                        alt="Galilea"
                                      />
                                    </div>
                                    <div className="grid content-center">
                                      <div>{friend?.name}</div>
                                      <div className="text-grayP text-sm">
                                        {friend?.status}
                                      </div>
                                    </div>
                                  </div>
                                  {friend.negativePoints ? (
                                    <div className="grid content-center text-red text-sm">
                                      -{friend.negativePoints} puntos
                                    </div>
                                  ) : (
                                    <div className="grid content-center text-green text-sm">
                                      +{friend.points} puntos
                                    </div>
                                  )}
                                </div>
                                <div className="text-grayP text-xs pt-4">
                                  {friend.description}
                                </div>
                                <div className="flex justify-end text-grayP">
                                  <div className="bg-purpleLight rounded-full">
                                    <ChatBubbleOvalLeftIcon className="w-4 h-auto m-1" />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        )
                    }
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
